/**
 * Build stamp — OVERWRITTEN at build time by scripts/inject-build-env.js.
 * The committed values are intentionally empty (local builds are unstamped).
 *
 * Why a generated source file instead of just `process.env.EXPO_PUBLIC_COMMIT_SHA`
 * (CORE-308): babel inlines EXPO_PUBLIC_* at transform time, but the value is NOT
 * part of metro's cache key. Our GitLab shell runners share one /tmp/metro-cache
 * across build directories, so building the same source tree twice — which is
 * exactly what a branch pipeline followed by the post-merge dev pipeline does —
 * served the second build a fully cached bundle carrying the FIRST build's SHA.
 * Observed: the dev deploy's .env.local said 67cbe7a2 while its emitted bundle
 * said ad522968, byte-identical to the branch build.
 *
 * A generated module dodges that: its CONTENT changes with the SHA, so the cache
 * key changes and metro re-transforms. Keep this file's shape stable — the build
 * script rewrites it wholesale.
 */
export const BUILD_SHA = '4032670e9b6a545568cccbaf7ae336685d165cd6';
export const BUILD_BRANCH = 'dev';
